/** Shared selling-price resolution for Error page, error-screen leads, and deferred errors. */

export const SELLING_PRICE_KEYS = ['sellingPrice', 'sellingprice', 'selling_price']

/** Selling-price fields only (excludes generic `price`). */
export const EXPLICIT_SELLING_PRICE_KEYS = ['sellingPrice', 'sellingprice', 'selling_price']

export const isSellingPriceMissingOrZero = (raw) => {
  if (raw === null || raw === undefined || raw === '') {
    return true
  }

  const n = Number(raw)

  return !Number.isFinite(n) || n === 0
}

export const mergeVehicleRecords = (vehicle, embedVehicle) => ({
  ...embedVehicle,
  ...vehicle,
})

export const hasVehicleIdentifier = (vehicle) =>
  Boolean(vehicle?.vin || vehicle?.stock || vehicle?.stock_number)

/**
 * Walk price fields in priority order. Skip nullish / empty / 0 so embed `sellingPrice: 0`
 * does not block a real API value on `sellingprice`.
 */
export const getResolvedSellingPrice = (vehicle) => {
  const merged = vehicle || {}

  for (const key of SELLING_PRICE_KEYS) {
    const raw = merged[key]

    if (!isSellingPriceMissingOrZero(raw)) {
      return raw
    }
  }

  return undefined
}

/**
 * True when a selling-price field is present and numerically zero (not merely absent).
 * Used for error-screen deferral: $0 selling price breaks payments even if MSRP exists.
 */
export const vehicleHasExplicitZeroSellingPrice = (vehicle, embedVehicle) => {
  const merged = mergeVehicleRecords(vehicle, embedVehicle)

  for (const key of EXPLICIT_SELLING_PRICE_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(merged, key)) {
      continue
    }

    const raw = merged[key]

    if (raw === null || raw === undefined || raw === '') {
      continue
    }

    const n = Number(raw)

    if (Number.isFinite(n) && n === 0) {
      return true
    }
  }

  return false
}

/** True when every price field is missing or zero and the record has a vehicle identifier. */
export const vehicleHasNoSellingPrice = (vehicle, embedVehicle) => {
  const merged = mergeVehicleRecords(vehicle, embedVehicle)

  for (const key of SELLING_PRICE_KEYS) {
    const raw = merged[key]

    if (!isSellingPriceMissingOrZero(raw)) {
      return false
    }
  }

  return hasVehicleIdentifier(merged)
}
